<template>
  <!-- STRANKA ROUTOVACI SKUPINY PREHLED -->
  <div class="list-page">
    <div v-if="project && project.projectId != 'undefined'">
      <div class="layout__content__header list-page__header layout__content__header--white">
        <div v-if="project" class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("routovaciSkupiny") }}
          </h1>
          <div class="list-page__buttons align-items-center d-flex d-sm-none">
            <button
              class="btn btn-primary d-flex align-items-center justify-content-center"
              @click="$router.push({ name: 'dataFlowNew', params: $route.params })"
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-nova.svg" />
              </div>
              {{ $t("novaRoutovaciSkupina") }}
            </button>
          </div>
        </div>
        <div v-if="project" class="d-flex justify-content-between">
          <div class="d-flex list-page__left align-items-center">
            <div
              class="custom-control custom-control--search d-flex align-items-center justify-content-between list-page__search"
            >
              <!--div v-if="suggested != ''" class="custom-control--search__suggested"><span class="atom-tag" @click="suggested = ''">{{suggested}}</span></div-->
              <input
                id="guisearch"
                ref="searchInput"
                v-model="search"
                :placeholder="this.$t('Hledat podle názvu, ID, tagu, …')"
                autofocus
                class="w-100"
                type="text"
                @keyup.enter="searchGroups()"
              />
              <div v-if="search" class="atom-icon" @click="clearSearch()">
                <img src="@/assets/icons/actions/ico-close.svg" />
              </div>
              <div class="atom-icon last" @click="searchGroups()">
                <img src="@/assets/icons/actions/ico-search-black.svg" />
              </div>
              <div class="custom-control--search__suggestions">
                <div
                  v-for="(suggestion, index) in suggestionsArray"
                  :key="index"
                  class="custom-control--search__suggestions__item"
                  @click="setSuggestion(suggestion)"
                >
                  <span>{{ suggestion }}</span>
                </div>
              </div>
            </div>
            <!--      Zakomentováno v rámci řešení bugfixu issue #9 pro další budoucí část vývoje
            <div class="list-page__link">
              <a class="d-flex align-items-center">
                {{ $t("pokrocilaFiltrace") }}
                <img src="@/assets/icons/arrows/arr-orange-down.svg" class="" />
              </a>
            </div> -->
          </div>
          <div class="list-page__buttons d-none d-sm-flex align-items-center justify-content-between">
            <button
              class="btn btn-primary d-flex align-items-center justify-content-center"
              @click="$router.push({ name: 'dataFlowNew', params: $route.params })"
            >
              <div class="atom-icon">
                <img src="@/assets/icons/actions/ico-btn-nova.svg" />
              </div>
              {{ $t("novaRoutovaciSkupina") }}
            </button>
          </div>
        </div>
      </div>

      <div class="layout__content__header layout__content__header--white pt-0 pb-0">
        <RadioHelp
          :article-link="'/groups'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <div v-if="radioSlides.length" class="detail-page__tabs__header d-flex">
        <div class="d-flex align-items-end detail-page__tabs__wrapper mt-5">
          <RadioOpenClose
            :radio-slides="radioSlides"
            :show="showHelp"
            @update-show-radio-help="showRadioHelp($event)"
          />
        </div>
      </div>
      <div v-if="sortedGroups.length > 0" class="layout__content__content pt-4 pt-md-5">
        <div v-click-outside="closeDropdownActions" class="dropdown-actions">
          <button v-if="selectedRows.length > 0" class="btn btn-primary" @click="showDropdownActions()">
            <div class="d-flex align-items-center">
              {{ $t("hromadneAkce") }}
              <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
            </div>
          </button>
          <button v-else class="btn btn-primary" disabled>
            <div class="d-flex align-items-center">
              {{ $t("hromadneAkce") }}
              <img class="ml-2" src="@/assets/icons/arrows/arr-down-white.svg" />
            </div>
          </button>
          <div v-if="isActionsDropdownVisible" class="dropdown-actions__wrapper dropdown-actions__wrapper--small">
            <div class="dropdown-actions__inner">
              <div class="row">
                <!--b-col cols="12" class="dropdown-actions__item d-flex align-items-center">
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-label.svg">
                  </div>
                  {{ $t("pridatTag") }}
                </b-col>
                <b-col cols="12" class="dropdown-actions__item d-flex align-items-center">
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-label.svg">
                  </div>
                  {{ $t("odebratTag") }}
                </b-col-->
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleAddEndpointsModal('addToEndpoints')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                  </div>
                  {{ $t("priraditEndpoint") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleRemoveEndpointsModal('removeEndpoints')
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                  </div>
                  {{ $t("odebratEndpoint") }}
                </div>
                <div
                  class="dropdown-actions__item d-flex align-items-center justify-content-center justify-content-sm-start col-12"
                  @click="
                    () => {
                      actionItems = selectedRows
                      toggleDeleteGroup(selectedRows)
                      isActionsDropdownVisible = false
                    }
                  "
                >
                  <div class="atom-icon">
                    <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                  </div>
                  {{ $t("smazatSkupinu") }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end mb-md-4 mt-3 mt-md-0">
          <span class="font-weight-light">{{ $t("vybrano") }}: {{ selectedRows.length }}</span>
          <span v-if="selectedRows.length != sortedGroups.length" class="link ml-4" @click="selectAll('selectAll')">
            {{ $t("vybratVse") }}
          </span>
          <span v-if="selectedRows.length > 0" class="link ml-2" @click="selectAll('deselect')">
            {{ $t("OdvybratVse") }}
          </span>
        </div>

        <div v-if="sortedGroups.length > 0" class="position-relative w-100">
          <div id="groups" class="table-responsive">
            <table class="table table-main table-hover">
              <thead>
                <tr>
                  <th
                    v-for="(column, index) in columns"
                    :key="index"
                    :class="{ isHidden: !column.visible }"
                    :style="{ 'min-width': column.minWidth }"
                  >
                    <span v-if="column.sortable != true">
                      {{ $t(column.name) }}
                    </span>
                    <span v-else>
                      <div
                        v-if="column.name === 'deviceGroupName'"
                        :class="{ checked: allOnPageSelected() }"
                        class="custom-control custom-control--checkbox"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortBy(column.type)">
                        {{ $t(column.name) }}
                      </div>
                      <div v-if="sort === column.type" class="sorting">
                        <span v-if="sortType === 'desc'">▼</span>
                        <span v-if="sortType === 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, item_index) in sortedGroups.slice(
                    this.page * Number(this.rowsPerPage),
                    this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                  )"
                  :key="item_index"
                >
                  <td
                    v-for="(column, column_index) in columns"
                    :key="column_index"
                    :class="{
                      isHidden: !column.visible
                    }"
                    :style="{ width: column.minWidth }"
                  >
                    <span v-if="column.type == 'deviceGroupName'">
                      <div
                        :class="{
                          checked: selectedRows.filter((e) => e.deviceGroupId === item.deviceGroupId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <RouterLink
                        :to="{
                          name: 'group',
                          params: {
                            id: item.deviceGroupId,
                            group: item
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span :style="{ maxWidth: column.minWidth }" style="display: block; word-wrap: break-word">
                          {{ item[column.type] }}
                        </span>
                      </RouterLink>
                    </span>
                    <span
                      v-else-if="column.type == 'deviceGroupDesc'"
                      :style="{ maxWidth: column.minWidth }"
                      style="display: block; word-wrap: break-word"
                    >
                      <span>{{ item.deviceGroupDesc }}</span>
                    </span>
                    <span v-else-if="column.type == 'devices'">
                      <div v-if="item.devicesShortlist.length <= 30">
                        <div v-for="device in item.devicesShortlist.slice(0, 1)" :key="device.deviceId" class="d-flex">
                          <RouterLink
                            :to="{
                              name: device.deviceProtocol === 'mqtt' ? 'mqttDevice' : 'device',
                              params: { id: device.deviceId }
                            }"
                            class="link-gray"
                          >
                            <span>
                              {{ device.custDeviceName }}
                            </span>
                          </RouterLink>
                          <div v-if="item.devicesShortlist.length > 1" class="atom-expand" @click="toggleDevices(item)">
                            <span v-if="!!openedDevices.find((g) => g.deviceGroupId)">-</span>
                            <span v-else>+</span>
                            {{ item.devices - 1 }}
                          </div>
                        </div>
                        <div
                          v-if="!!openedDevices.find((g) => g.deviceGroupId)"
                          class="atom-expand__content d-flex flex-wrap"
                        >
                          <div
                            v-for="device in item.devicesShortlist.slice(1, item.devicesShortlist.length)"
                            :key="device.deviceId"
                          >
                            <RouterLink
                              :to="{
                                name: device.deviceProtocol === 'mqtt' ? 'mqttDevice' : 'device',
                                params: { id: device.deviceId }
                              }"
                              class="link-gray"
                            >
                              <span>
                                {{ device.custDeviceName }}
                              </span>
                            </RouterLink>
                          </div>

                          <a
                            v-if="item.devices > 30"
                            class="link-gray"
                            @click="
                              $router.push({
                                name: 'group',
                                params: {
                                  id: item.deviceGroupId
                                }
                              })
                            "
                          >
                            <span>{{ $t("dalsi") }}</span>
                          </a>
                        </div>
                      </div>
                      <div v-else>> 30</div>
                    </span>
                    <div v-else-if="column.type == 'endpoints'">
                      <div v-if="item.endpointsShortlist.length <= 30">
                        <div
                          v-for="endpoint in item.endpointsShortlist.slice(0, 1)"
                          :key="endpoint.custDestId"
                          class="d-flex"
                        >
                          <RouterLink
                            :to="{
                              name: endpoint.custDestType === 'mqtt' ? 'mqttEndpoint' : 'endpoint',
                              params: { id: endpoint.custDestId }
                            }"
                            class="link-gray"
                          >
                            <span>
                              {{ endpoint.custDestName }}
                            </span>
                          </RouterLink>
                          <div
                            v-if="item.endpointsShortlist.length > 1"
                            class="atom-expand"
                            @click="toggleEndpoints(item)"
                          >
                            <span v-if="!!openedEndpoints.find((g) => g.deviceGroupId)">-</span>
                            <span v-else>+</span>
                            {{ item.endpoints - 1 }}
                          </div>
                        </div>
                        <div
                          v-if="!!openedEndpoints.find((g) => g.deviceGroupId)"
                          class="atom-expand__content d-flex flex-wrap"
                        >
                          <div
                            v-for="endpoint in item.endpointsShortlist.slice(1, item.endpointsShortlist.length)"
                            :key="endpoint.custDestId"
                            class=""
                          >
                            <RouterLink
                              :to="{
                                name: endpoint.custDestType === 'mqtt' ? 'mqttEndpoint' : 'endpoint',
                                params: { id: endpoint.custDestId }
                              }"
                              class="link-gray"
                            >
                              <span>
                                {{ endpoint.custDestName }}
                              </span>
                            </RouterLink>
                          </div>

                          <a
                            v-if="item.endpoints > 30"
                            class="link-gray"
                            @click="
                              $router.push({
                                name: 'group',
                                params: {
                                  id: item.deviceGroupId,
                                  tab: 2
                                }
                              })
                            "
                          >
                            <span>{{ $t("dalsi") }}</span>
                          </a>
                        </div>
                      </div>
                      <div v-else>> 30</div>
                    </div>
                    <span v-else>
                      {{ item[column.type] }}
                    </span>
                  </td>
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedGroup.deviceGroupId == item.deviceGroupId
                      }"
                      class="kebab"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-first-column">
              <thead>
                <tr>
                  <th>
                    <span v-if="columns[0].sortable != true">
                      {{ $t(columns[0].name) }}
                    </span>
                    <span v-else class="d-flex align-items-center">
                      <div
                        v-if="columns[0].name == 'deviceGroupName'"
                        :class="{
                          checked: allOnPageSelected()
                        }"
                        class="custom-control custom-control--checkbox"
                        @click="selectAll()"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>
                      <div class="title" @click="sortBy(columns[0].type)">
                        {{ $t(columns[0].name) }}
                      </div>
                      <div v-if="sort == columns[0].type" class="sorting">
                        <span v-if="sortType == 'desc'">▼</span>
                        <span v-if="sortType == 'asc'">▲</span>
                      </div>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, item_index) in sortedGroups.slice(
                    this.page * Number(this.rowsPerPage),
                    this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                  )"
                  :key="item_index"
                >
                  <td :style="{ width: columns[0].minWidth }">
                    <span>
                      <div
                        :class="{
                          checked: selectedRows.filter((e) => e.deviceGroupId === item.deviceGroupId).length > 0
                        }"
                        class="custom-control custom-control--checkbox"
                        style="display: inline-block"
                        @click="addToSelected(item)"
                      >
                        <input class="custom-control-input" type="checkbox" />
                      </div>

                      <RouterLink
                        :to="{
                          name: 'group',
                          params: {
                            id: item.deviceGroupId,
                            group: item,
                            customerId: customerId,
                            projectId: projectId
                          }
                        }"
                        class="font-weight-bolder link-gray"
                      >
                        <span :style="{ maxWidth: columns[0].minWidth }" style="display: block; word-wrap: break-word">
                          {{ item.deviceGroupName }}
                        </span>
                      </RouterLink>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table :class="{ showShadow: showShadow }" class="table table-hover fixed-last-column">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, item_index) in sortedGroups.slice(
                    this.page * Number(this.rowsPerPage),
                    this.page * Number(this.rowsPerPage) + Number(this.rowsPerPage)
                  )"
                  :key="item_index"
                >
                  <td>
                    <div
                      id="kebab"
                      ref="kebab"
                      :class="{
                        opened: openedGroup.deviceGroupId == item.deviceGroupId
                      }"
                      class="kebab"
                    >
                      <div class="dropdown-actions">
                        <div class="atom-icon mr-0" @click="openKebab(item)">
                          <img src="@/assets/icons/menu/ico-kebab.svg" />
                        </div>
                        <div
                          v-if="openedGroup.deviceGroupId == item.deviceGroupId"
                          v-click-outside="closeKebabConf"
                          class="dropdown-actions__wrapper"
                        >
                          <div class="dropdown-actions__inner">
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              @click="
                                () => {
                                  actionItems = [openedGroup]
                                  toggleEditGroupModal('editGroup')
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-zmenaskupiny.svg" />
                              </div>
                              {{ $t("upravitSkupinu") }}
                            </div>
                            <div
                              class="dropdown-actions__item d-flex align-items-center"
                              cols="6"
                              @click="
                                () => {
                                  actionItems = [openedGroup]
                                  toggleDeleteGroup([item])
                                }
                              "
                            >
                              <div class="atom-icon">
                                <img src="@/assets/icons/actions/ico-ico-delete-l.svg" />
                              </div>
                              {{ $t("odstranitSkupinu") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          v-if="sortedGroups.length > 0"
          class="custom-table__footer d-flex align-items-center justify-content-between"
        >
          <div class="custom-table__footer__actions align-items-center">
            <p class="link-gray mb-0" style="margin-right: 10px" @click="showSidebarTableColumnOrder = true">
              <span>{{ $t("upravitSloupce") }}</span>
            </p>
            <p v-if="!toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
              <span>{{ $t("rozbalitVsechnyRadky") }}</span>
            </p>
            <p v-if="toggledAllRows" class="link-gray mb-0" @click="toggleAllRows()">
              <span>{{ $t("sbalitVsechnyRadky") }}</span>
            </p>
          </div>
          <Paging
            :page="{
              currentPage: page,
              rowsPerPage: rowsPerPage,
              itemsTotalCount: sortedGroups.length,
              itemsCount: sortedGroups.length
            }"
            @page="page = $event"
            @next-page="page++"
            @prev-page="page--"
            @rows-per-page="rowsPerPage = $event"
          />
        </div>
      </div>

      <div v-else-if="!loadingData" class="layout__content__content pt-4 pt-md-5">
        {{ $t("zadneSkupinyKZobrazeni") }}
      </div>
      <div v-else class="layout__content__content pt-4 pt-md-5">
        <AppLoader />
      </div>
    </div>

    <div v-else>
      <div class="layout__content__header list-page__header">
        <div class="d-flex flex-wrap mb-4 mb-sm-0 justify-content-between">
          <h1 class="mb-1 mb-sm-4">
            {{ $t("routovaciSkupiny") }}
          </h1>
        </div>
      </div>
    </div>
    <NewGroupModal
      :opened="openedNewGroup"
      @close-box="toggleNewGroupModal"
      @open-box="toggleNewGroupModal"
      @reload-items="loadGroups"
    />
    <DeleteGroupModal
      :centered="true"
      :items="actionItems"
      :opened="openedDeleteGroup"
      :text="deleteText"
      @close="toggleDeleteGroup()"
      @yes="
        () => {
          deleteGroup()
          toggleDeleteGroup()
        }
      "
      @update-items="loadGroups"
    />
    <AddEndpointModal
      :devices="actionItems"
      :opened="openedAddEndpoints"
      @close-box="toggleAddEndpointsModal"
      @open-box="toggleAddEndpointsModal"
      @update-items="loadGroups"
    />
    <RemoveEndpointModal
      :devices="actionItems"
      :opened="openedRemoveEndpoints"
      @close-box="toggleRemoveEndpointsModal"
      @open-box="toggleRemoveEndpointsModal"
      @update-items="loadGroups"
    />
    <EditGroupModal
      :device="actionItems[0]"
      :opened="openedEditGroup"
      @close-box="toggleEditGroupModal"
      @open-box="toggleEditGroupModal"
      @reload-items="loadGroups"
    />
    <TableColumnOrder
      v-if="showSidebarTableColumnOrder"
      :columns="tableColumns"
      :columns-type="columnsTypeName"
      :opened="showSidebarTableColumnOrder"
      @close-box="closeSidebarTableColumnOrder()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import Paging from "@/components/paging/paging.vue"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import DeleteGroupModal from "@/components/confirmations/delete.vue"
import AddEndpointModal from "@/components/modals/groups/addEndpoint.vue"
import RemoveEndpointModal from "@/components/modals/groups/removeEndpoint.vue"
import NewGroupModal from "@/components/modals/groups/new.vue"
import EditGroupModal from "@/components/modals/groups/edit.vue"
import TableColumnOrder from "@/components/modals/global/tableColumnOrder.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import Loader from "@/components/loader.vue"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"
import { useGroupsStore } from "@/store/modules/groups"

export default {
  components: {
    Paging,
    DeleteGroupModal,
    AddEndpointModal,
    RemoveEndpointModal,
    NewGroupModal,
    RadioHelp,
    RadioOpenClose,
    EditGroupModal,
    ErrorModal,
    TableColumnOrder,
    AppLoader: Loader
  },
  setup() {
    const projectStore = useProjectStore()
    const configStore = useConfigStore()
    const groupsStore = useGroupsStore()

    return { projectStore, configStore, groupsStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      tableWidth: 0,
      columns: [
        {
          type: "deviceGroupName",
          name: "deviceGroupName",
          sortable: true,
          visible: true,
          minWidth: "250px",
          order: 1
        },
        {
          type: "technologyDisplay",
          name: "TECHNOLOGY",
          sortable: true,
          visible: true,
          minWidth: "150px",
          order: 1
        },
        {
          type: "deviceGroupDesc",
          name: "popisSkupiny",
          sortable: false,
          visible: true,
          minWidth: "350px",
          order: 2
        },
        {
          type: "devices",
          name: "devices",
          sortable: true,
          visible: true,
          minWidth: "200px",
          order: 3
        },
        {
          type: "endpoints",
          name: "MENU_VYSTUPY",
          sortable: true,
          visible: true,
          minWidth: "200px",
          order: 4
        }
      ],
      columnsTypeName: "columnsGroups",
      selectedProject: JSON.parse(localStorage.getItem("selectedProject")),
      selectedCustomer: JSON.parse(localStorage.getItem("selectedCustomer")),
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      openedGroup: {},
      openedGroupTags: [],
      isHeaderFixed: false,
      isTableHeaderFixed: false,
      sort: "deviceGroupName",
      sortType: "asc",
      search: "",
      suggested: "",
      suggestionsArray: [],
      selectedRows: [],
      selectedAll: false,
      isSelectedAllOnPage: false,
      isActionsDropdownVisible: false,
      rowsPerPage: 20,
      page: 0,
      openedRowsSelect: false,
      toggledAllRows: false,
      loaded: false,
      loadingData: true,
      sortedGroups: [],
      openedDeleteGroup: false,
      deleteText: "",
      openedAddEndpoints: [],
      openedRemoveEndpoints: [],
      openedNewGroup: [],
      openedEditGroup: [],
      openedEndpoints: [],
      openedDevices: [],
      actionItems: [],
      errorsToTranslate: [],
      openedError: false,
      closeKebabConf: {
        handler: this.closeKebab,
        middleware: this.middlewareKebab,
        events: ["dblclick", "click"],
        isActive: true,
        detectIFrame: true,
        capture: false
      },
      tableColumnsDefault: {
        technologyDisplay: {
          show: true,
          order: 2,
          title: "TECHNOLOGY"
        },
        deviceGroupDesc: {
          show: true,
          order: 3,
          title: "popisSkupiny"
        },
        devices: {
          show: true,
          order: 4,
          title: "devices"
        },
        endpoints: {
          show: true,
          order: 5,
          title: "MENU_VYSTUPY"
        }
      },
      showSidebarTableColumnOrder: false,
      tableColumns: {},
      showShadow: false
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    },
    openNewGroupModalOnLoad() {
      return this.$store.getters["modals/ifNewGroupVisible"]
    },
    groups() {
      return this.groupsStore.groups
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    }
  },
  watch: {
    project() {
      this.sortedGroups = []
      this.loadGroups()
      this.selectedRows = []
      this.isSelectedAllOnPage = false
      //this.searchGroups();
    },
    openNewGroupModalOnLoad() {
      this.onloadNewGroup()
    },
    search() {
      if (this.suggested == "") {
        if (this.search.length > 1) {
          this.suggestions()
        }
      } else {
        this.suggested = ""
      }
    },
    rowsPerPage() {
      this.page = 0
      localStorage.rowsPerPage = this.rowsPerPage
    },
    page() {
      this.isSelectedAllOnPage = false
      var selectedGroups = this.groups.slice(
        this.page * this.rowsPerPage,
        this.page * this.rowsPerPage + this.rowsPerPage
      )
      let selectedGroupsId = selectedGroups.map((d) => d.custDestId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let groupsId = selectedAllRowsArray.map((d) => d.custDestId)

      this.isSelectedAllOnPage = selectedGroupsId.every((ai) => groupsId.includes(ai))
    },
    radioDisabled: {
      handler() {
        this.showHelp = !this.radioDisabled
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    })

    this.onloadNewGroup()

    this.tableColumns = this.getTableColumns()

    if (localStorage.rowsPerPage) {
      var rows = localStorage.rowsPerPage
      this.rowsPerPage = rows
    } else {
      localStorage.rowsPerPage = this.rowsPerPage
    }
    if (this.project) {
      this.loadGroups()
    }

    const tabsElement = document.getElementById("tabs")
    window.document.onscroll = () => {
      if (tabsElement) {
        this.isHeaderFixed = window.scrollY > tabsElement.offsetTop + 250
      }
    }

    this.updateResponsiveTable()
  },
  unmounted() {
    window.document.onscroll = undefined
  },
  methods: {
    onloadNewGroup() {
      if (this.openNewGroupModalOnLoad) {
        this.toggleNewGroupModal("newGroup")
        this.$store.commit("modals/setNewGroupVisible", {
          showNewEndpoint: false
        })
      }
    },
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    updateResponsiveTable() {
      this.$updateResponsiveTable(this, "groups")
    },
    async loadGroups() {
      if (
        this.$route.params.notifications &&
        this.$route.params.notifications[0] &&
        this.$route.params.notifications[0].text
      ) {
        this.$store.commit("modals/setGlobalNotification", this.$route.params.notifications)
      }
      this.loaded = false
      const groupsLoaded = await this.groupsStore.getGroups()

      if (groupsLoaded) {
        this.selectedRows = []
        this.loaded = true
        this.loadingData = false
        this.sortedGroups = this.groups.map((df) => ({
          ...df,
          technologyDisplay: df.technology === "LORA" ? this.$t("lora") : this.$t(df.technology ?? "")
        }))
        this.getAllTags()
        if (this.search != "") {
          this.searchGroups()
        }
        this.$nextTick(this.updateResponsiveTable)
      }
    },
    allOnPageSelected() {
      let itemsOnPage = this.groups.slice(
        this.page * this.rowsPerPage,
        Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage)
      )

      let itemsOnPageId = itemsOnPage.map((d) => d.deviceGroupId)
      let allItemsId = Array.from(this.selectedRows).map((d) => d.deviceGroupId)

      if (itemsOnPageId.every((ai) => allItemsId.includes(ai))) {
        return true
      } else {
        return false
      }
    },
    toggleDeleteGroup(items) {
      if (this.openedDeleteGroup == true) {
        this.openedDeleteGroup = false
        this.deleteText = ""
      } else {
        if (items) {
          if (items.length > 1 && items.length < 5) this.deleteText = this.$t("skupiny")
          else if (items.length >= 5) this.deleteText = this.$t("skupin")
          else this.deleteText = items[0].deviceGroupName
        }
        this.openedDeleteGroup = true
      }
    },
    deleteGroup() {
      this.errorsToTranslate = []
      let promises = []
      let notifications = []
      this.actionItems.forEach((item) => {
        let id = item.deviceGroupId
        promises.push(
          axios
            .delete(process.env.VUE_APP_API + "/device-groups/" + id)
            .then((response) => {
              if (response.status == 204) {
                notifications.push({
                  text: "notificationGroupDelete",
                  error: false,
                  params: {
                    deviceGroupId: item.deviceGroupId,
                    deviceGroupName: item.deviceGroupName
                  }
                })
                this.sortedGroups.splice(this.sortedGroups.indexOf(item), 1)
                this.selectedRows.splice(this.selectedRows.indexOf(item), 1)
              }
            })
            .catch((error) => {
              let message = error.data.errors[0]
              error.data.errors = []
              error.data.errors.push({
                message: message,
                attribute: {
                  deviceGroupName: item.deviceGroupName,
                  deviceGroupId: item.deviceGroupId
                }
              })
              this.errorsToTranslate.push(error.data)
            })
        )
      })
      Promise.all(promises).then(() => {
        this.$store.commit("modals/setGlobalNotification", notifications)
        this.openedError = true
        this.loadGroups()
      })
    },
    toggleNewGroupModal(box) {
      if (this.openedNewGroup.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedNewGroup = []
        } else {
          this.openedNewGroup = this.openedNewGroup.filter((b) => b !== box)
        }
        this.isActionsDropdownVisible = false
      } else {
        this.openedNewGroup = this.openedNewGroup.concat([box])
      }
    },
    toggleEditGroupModal(box) {
      if (this.openedEditGroup.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedEditGroup = []
        } else {
          this.openedEditGroup = this.openedEditGroup.filter((b) => b !== box)
        }
        this.isActionsDropdownVisible = false
      } else {
        this.openedEditGroup = this.openedEditGroup.concat([box])
      }
    },
    toggleAddEndpointsModal(box) {
      if (this.openedAddEndpoints.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedAddEndpoints = []
        } else {
          this.openedAddEndpoints = this.openedAddEndpoints.filter((b) => b !== box)
        }
        this.isActionsDropdownVisible = false
      } else {
        this.openedAddEndpoints = this.openedAddEndpoints.concat([box])
      }
    },
    toggleRemoveEndpointsModal(box) {
      if (this.openedRemoveEndpoints.indexOf(box) > -1) {
        if (box === undefined) {
          this.openedRemoveEndpoints = []
        } else {
          this.openedRemoveEndpoints = this.openedRemoveEndpoints.filter((b) => b !== box)
        }
        this.isActionsDropdownVisible = false
      } else {
        this.openedRemoveEndpoints = this.openedRemoveEndpoints.concat([box])
      }
    },
    toggleDevices(device) {
      const index = this.openedDevices.indexOf(device)
      if (this.openedDevices.indexOf(device) > -1) {
        this.openedDevices = this.openedDevices.filter((d, i) => i !== index)
        this.openedDevices.splice(index, 1)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedDevices = this.openedDevices.concat([device])
      }
    },
    toggleEndpoints(device) {
      var index = this.openedEndpoints.indexOf(device)
      if (this.openedEndpoints.indexOf(device) > -1) {
        this.openedEndpoints = this.openedEndpoints.filter((d, i) => i !== index)
        if (this.toggledAllRows) this.toggledAllRows = false
      } else {
        this.openedEndpoints = this.openedEndpoints.concat([device])
      }
    },
    sortBy(sortBy) {
      let sorted
      this.isSelectedAllOnPage = false
      this.sort = sortBy
      if (this.sortType == "asc") {
        sorted = _.orderBy(this.sortedGroups, `${sortBy}`, "desc")
        this.sortType = "desc"
      } else {
        sorted = _.orderBy(this.sortedGroups, `${sortBy}`, "asc")
        this.sortType = "asc"
      }
      this.dateChanged = false
      this.sortedGroups = sorted
    },
    toggleTag(group) {
      var index = this.openedGroupTags.indexOf(group)
      if (this.openedGroupTags.indexOf(group) > -1) {
        this.openedGroupTags.splice(index, 1)
      } else {
        this.openedGroupTags.push(group)
      }
    },
    copyToClipboard(text) {
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    openKebab(group) {
      this.openedGroup = this.openedGroup == group ? {} : group
    },
    searchGroups() {
      this.suggestionsArray = []
      this.sortedGroups = this.groups.filter(
        (group) =>
          group.deviceGroupName.toLowerCase().indexOf(this.search.toLowerCase()) !== -1 ||
          group.deviceGroupDesc.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
      )
    },
    suggestions() {
      axios
        .get(
          process.env.VUE_APP_API +
            "/device-groups/suggestions?projectId[eq]=" +
            this.selectedProject.projectId +
            "&search=" +
            this.search +
            "*",
          {}
        )
        .then((response) => {
          this.suggestionsArray = response.data.data
        })
        .catch(() => {})
    },
    setSuggestion(suggestion) {
      this.suggested = suggestion
      this.search = suggestion
      this.searchGroups()
      this.suggestionsArray = []
    },
    clearSearch() {
      this.suggestionsArray = []
      this.search = ""
      this.suggested = ""
      this.loadGroups()
    },
    addToSelected(group) {
      if (this.selectedRows.filter((e) => e.deviceGroupId === group.deviceGroupId).length > 0) {
        const index = this.selectedRows.map((e) => e.deviceGroupId).indexOf(group.deviceGroupId)

        this.selectedRows.splice(index, 1)
      } else {
        this.selectedRows.push(group)
      }
    },
    selectAll(type) {
      this.isSelectedAllOnPage = true
      var selectedDevices = this.sortedGroups.slice(
        this.page * this.rowsPerPage,
        Number(this.page * this.rowsPerPage) + Number(this.rowsPerPage)
      )
      let selectedGroupsId = selectedDevices.map((d) => d.deviceGroupId)
      let selectedAllRowsArray = Array.from(this.selectedRows)
      let allGroupsId = selectedAllRowsArray.map((d) => d.deviceGroupId)
      if (type === "deselect") {
        this.selectedRows = []
        this.isSelectedAllOnPage = false
      } else if (type === "selectAll") {
        this.selectedRows = [].concat.apply([], this.sortedGroups)
        this.isSelectedAllOnPage = true
      } else {
        if (selectedGroupsId.every((ai) => allGroupsId.includes(ai))) {
          let indexes = []
          selectedDevices.forEach((element) => {
            indexes.push(selectedAllRowsArray.indexOf(element))
          })
          indexes.forEach((index) => {
            this.selectedRows.splice(index)
          })
          this.isSelectedAllOnPage = false
        } else {
          let indexes = []
          let same = []
          this.selectedRows.forEach((selected) => {
            let filteredArray = selectedDevices.filter((e) => e.deviceGroupId === selected.deviceGroupId)
            same.push(filteredArray[0])
          })
          same.forEach((element) => {
            if (element != undefined) {
              indexes.push(this.selectedRows.findIndex((obj) => obj.deviceGroupId == element.deviceGroupId))
            }
          })
          for (var i = indexes.length - 1; i >= 0; i--) {
            this.selectedRows.splice(indexes[i], 1)
          }

          this.selectedRows =
            this.selectedRows.length > 0
              ? this.selectedRows.concat.apply(this.selectedRows, selectedDevices)
              : [].concat.apply([], selectedDevices)
        }
      }
    },
    showDropdownActions() {
      this.isActionsDropdownVisible = !this.isActionsDropdownVisible
    },
    toggleOpenedRowSelect() {
      this.openedRowsSelect = !this.openedRowsSelect
    },
    updateGroups(groups) {
      console.log("updateGroups")
      this.selectedRows = []
      groups.forEach((group) => {
        let objIndex = this.sortedGroups.findIndex((obj) => obj.deviceGroupId == group.deviceGroupId)
        this.sortedGroups[objIndex] = group

        this.openedTags.push(group)
        this.openedGroups.push(group)
      })
    },
    toggleAllRows() {
      if (this.toggledAllRows) {
        this.openedGroupTags = []
        this.openedDevices = []
        this.openedEndpoints = []
        this.toggledAllRows = false
      } else {
        this.openedGroupTags = [].concat(this.groups)
        this.openedDevices = [].concat(this.groups)
        this.openedEndpoints = [].concat(this.groups)
        this.toggledAllRows = true
      }
    },
    getAllTags() {
      let tags = _(this.sortedGroups)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
      this.tags = _.uniq(tags)
    },
    closeDropdownActions() {
      this.isActionsDropdownVisible = false
    },
    closeKebab() {
      this.openedGroup = {}
    },
    middleware(event) {
      return event.target.className !== "kebab"
    },
    closeSidebarTableColumnOrder() {
      this.tableColumns = this.getTableColumns()
      this.showSidebarTableColumnOrder = false
      this.$nextTick(() => {
        this.updateResponsiveTable()
      })
    },
    getTableColumns() {
      const localStorageItemsJSON = localStorage.getItem(this.columnsTypeName)
      if (!localStorageItemsJSON) {
        return this.tableColumnsDefault
      }

      const localStorageItems = JSON.parse(localStorageItemsJSON)

      if (Object.keys(localStorageItems).length !== Object.keys(this.tableColumnsDefault).length) {
        return this.tableColumnsDefault
      }
      return localStorageItems
    }
  }
}
</script>

<style scoped></style>
